// Mock data for A Homely Abode — TO BE REPLACED BY BACKEND API in the future.
// Listings, case studies (proven results), testimonials, awards, blogs all
// expose exactly 3 placeholder records so the layout previews realistically.

export const SERVICES = [
  {
    title: "Portfolio Growth",
    body: "Customized investment plans designed to build long-term wealth in the property landscape.",
    n: "01",
  },
  {
    title: "Risk Management",
    body: "Strategic frameworks to minimize risks and safeguard your capital in fluctuating markets.",
    n: "02",
  },
  {
    title: "Personalized Service",
    body: "Every client receives dedicated attention, with a tailored roadmap aligned with their goals, timelines, and unique circumstances.",
    n: "03",
  },
  {
    title: "Market Expertise",
    body: "Insights on the latest real estate trends, regulations, opportunities, and neighbourhood dynamics.",
    n: "04",
  },
  {
    title: "Project Analysis",
    body: "Feasibility study and ROI assessments to help you identify winning developments and avoid pitfalls.",
    n: "05",
  },
  {
    title: "Exit Plan",
    body: "Clear, strategic exit strategies to ensure optimum returns when you are ready to sell or upgrade.",
    n: "06",
  },
];

export const MARKETING = [
  {
    title: "Social Media Campaigns",
    body: "Amplify your property's exposure on Facebook, Instagram, LinkedIn, and more.",
    n: "01",
  },
  {
    title: "YouTube Showcases",
    body: "High-impact video tours and expert insights that draw buyers with compelling storytelling.",
    n: "02",
  },
  {
    title: "Listing Platforms",
    body: "Maximize visibility through various top portals like PropertyGuru and 99.co.",
    n: "03",
  },
  {
    title: "Professional Photography & Videography",
    body: "Captivating visuals that bring your sales listings to life and attract qualified buyers.",
    n: "04",
  },
  {
    title: "Buyer Pivoting Strategies",
    body: "Targeted outreach techniques that pivot messaging and marketing efforts toward high-converting buyer segments.",
    n: "05",
  },
  {
    title: "Project Analysis & Exit Plan",
    body: "Comprehensive analysis and clear exit strategies for every project.",
    n: "06",
  },
];

export const FRAMEWORK_STEPS = [
  {
    n: "W",
    label: "The Entry",
    title: "Where You Start Matters",
    body:
      "Your first property isn't just a home — it's your first financial move. Getting the entry right sets the foundation for everything that follows. Most people underestimate how much this single decision shapes the next 20 years.",
  },
  {
    n: "A",
    label: "The Upgrade",
    title: "Assets Work Harder Than You",
    body:
      "The shift from \"bigger home\" to \"asset that grows\" is everything. Upgrading strategically — using equity, not just income — means your property is compounding on your behalf while you sleep.",
  },
  {
    n: "T",
    label: "The Hold",
    title: "Time Is the Real Return",
    body:
      "80% of property wealth comes from 20% of the right decisions made early. Staying in the right asset long enough — with a clear exit plan — outperforms timing the market every single time.",
  },
  {
    n: "E",
    label: "The Income",
    title: "Earn Without Showing Up",
    body:
      "When your property generates rental income, you stop trading time for money. Your lifestyle stops depending on your salary. This doesn't require multiple properties, just the right one, structured well.",
  },
  {
    n: "R",
    label: "The Freedom",
    title: "Rightsize From Strength, Not Need",
    body:
      "The goal isn't to downgrade. It's to build enough so that rightsizing becomes a wealthy person's choice — not a necessity. This is retirement funded by property, not by hope.",
  },
];

export const FRAMEWORK_INTRO = {
  acronym: "W.A.T.E.R",
  quote:
    "Your home isn't just where you live — it's how you build the life you want.",
  body:
    "A strategic framework for Singapore homeowners who want to stop sitting on equity and start building real wealth — deliberately, not by accident.",
};

/* ============================
   PLACEHOLDER DATA — 3 of each
   To be replaced by backend.
   ============================ */

export const LISTINGS = [
  {
    id: "L-001",
    title: "Sky Garden Residence",
    type: "Condominium",
    location: "Tanjong Pagar, District 02",
    price: "S$ 2,580,000",
    bedrooms: 3,
    bathrooms: 2,
    area: "1,184 sqft",
    tenure: "99-year leasehold",
    description:
      "North-east facing high-floor unit with unblocked skyline view, designer fittings, and full-condo facilities. A polished urban sanctuary minutes from Tanjong Pagar MRT.",
    image:
      "https://images.unsplash.com/photo-1605346475807-2088e0897b2d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxzaW5nYXBvcmUlMjBsdXh1cnklMjBjb25kbyUyMGludGVyaW9yfGVufDB8fHx8MTc4MDA1MTczN3ww&ixlib=rb-4.1.0&q=85",
    status: "Available",
    waMessage:
      "Hi Kiap, I'm interested in Sky Garden Residence (3BR, Tanjong Pagar). Could we arrange a viewing?",
  },
  {
    id: "L-002",
    title: "The Linden Villa",
    type: "Landed (Terrace)",
    location: "Serangoon Garden, District 19",
    price: "S$ 4,950,000",
    bedrooms: 5,
    bathrooms: 4,
    area: "2,820 sqft",
    tenure: "Freehold",
    description:
      "Quietly nestled in the heart of Serangoon Garden — recently rebuilt with warm interiors, private garden, and a rooftop terrace for slow weekends.",
    image:
      "https://images.unsplash.com/photo-1748063578185-3d68121b11ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBob21lJTIwZXh0ZXJpb3IlMjBtb2Rlcm4lMjB3YXJtJTIwbGlnaHR8ZW58MHx8fHwxNzgwMDUxNzQ0fDA&ixlib=rb-4.1.0&q=85",
    status: "Coming Soon",
    waMessage:
      "Hi Kiap, please add me to the early-access list for The Linden Villa in Serangoon Garden.",
  },
  {
    id: "L-003",
    title: "Punggol Riverside HDB",
    type: "HDB 5-Room",
    location: "Punggol Drive, District 19",
    price: "S$ 698,000",
    bedrooms: 4,
    bathrooms: 2,
    area: "1,184 sqft",
    tenure: "99-year leasehold",
    description:
      "Sun-drenched corner unit overlooking My Waterway @ Punggol. Lovingly maintained — ideal first home, or a smart entry into your upgrading journey.",
    image:
      "https://images.unsplash.com/photo-1629288124106-e6d8e752e686?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxzaW5nYXBvcmUlMjBsdXh1cnklMjBjb25kbyUyMGludGVyaW9yfGVufDB8fHx8MTc4MDA1MTczN3ww&ixlib=rb-4.1.0&q=85",
    status: "Sold",
    waMessage:
      "Hi Kiap, I'd like to learn more about your Punggol HDB success story and your services.",
  },
];

export const PROVEN_RESULTS = [
  {
    headline: "3 offers in 3 weeks",
    sub: "Punggol HDB sold above asking",
    metric: "+S$ 28,000",
    story:
      "A non-MRT-fronting Punggol HDB went under offer within 21 days through strategic listing copy, cinematic video tour, and targeted buyer pivoting.",
    image:
      "https://images.unsplash.com/photo-1629288124106-e6d8e752e686?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxzaW5nYXBvcmUlMjBsdXh1cnklMjBjb25kbyUyMGludGVyaW9yfGVufDB8fHx8MTc4MDA1MTczN3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    headline: "Upgrade journey completed",
    sub: "HDB → 3BR Condo, zero cash top-up",
    metric: "100% equity rolled",
    story:
      "A young family unlocked S$ 410k of equity from their HDB sale to fund a freehold condo upgrade — without a single dollar of fresh savings.",
    image:
      "https://images.unsplash.com/photo-1605346475807-2088e0897b2d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxzaW5nYXBvcmUlMjBsdXh1cnklMjBjb25kbyUyMGludGVyaW9yfGVufDB8fHx8MTc4MDA1MTczN3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    headline: "Multiple offers received",
    sub: "Bukit Timah Condo — 4 bids in 11 days",
    metric: "Sold +4.6% above asking",
    story:
      "Strategic staging, twilight photography, and a precision launch window drew four qualified buyers, closing well above expectations.",
    image:
      "https://images.unsplash.com/photo-1494526585095-c41746248156?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBob21lJTIwZXh0ZXJpb3IlMjBtb2Rlcm4lMjB3YXJtJTIwbGlnaHR8ZW58MHx8fHwxNzgwMDUxNzQ0fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "The housing agent, Kiap, I worked with was incredibly helpful and knowledgeable. He took the time to understand my needs and preferences, and was able to find multiple options that fit my budget and criteria. The video he took of my house for purpose of marketing was of good quality and demonstrated that he has the eye of details. I was pleasantly surprised that my house received 3 offers within a short span of 3 weeks given that the location in Punggol was far from MRT. He also assisted me in my current purchase of my HDB. What I was impressed with was his willingness and determination to look for the unit that fits my budget and criteria. I was about to settle for a smaller unit that I found on my own but he was quick to remind me the reason for me wanting to sell my house in the first place. If he had just go along with my wants back then, I would never have discover the gem of a place I am currently staying in. He was also very responsive and made the process of finding and securing a property much easier and less stressful. I highly recommend his services to anyone in need of a reliable and efficient housing agent.",
    name: "Muhammad Shazwan Bin Shahir",
    role: "Home Seller & Buyer",
  },
  {
    quote:
      "Kiap Yong certainly did his best to make our home buying a smooth journey. He even helped us on occasion to get a better deal or help us out with issues regarding the house. Overall, Kiap Yong has made tremendous effort in ensuring us a buyer a good journey!",
    name: "Zac",
    role: "Home Buyer",
  },
  {
    quote:
      "Placeholder testimonial — to be replaced via backend CMS. Real client quote, name, and role will live here once the API is connected. The layout supports any quote length and gracefully truncates long testimonials with a read-more toggle.",
    name: "Placeholder Client",
    role: "To be replaced by backend",
  },
];

export const AWARDS = [
  {
    year: "2024",
    title: "Top Producer Award",
    org: "ERA Realty Network",
    body: "Recognized for outstanding production and consistent client outcomes throughout the year.",
  },
  {
    year: "2023",
    title: "Diamond Achiever",
    org: "ERA Realty Network",
    body: "Awarded for sustained excellence in residential transactions and client satisfaction.",
  },
  {
    year: "2023",
    title: "Marketing Excellence",
    org: "Industry Recognition",
    body: "For pioneering YouTube-led property storytelling and high-conversion buyer pivoting strategies.",
  },
];

export const BLOGS = [
  {
    id: "b1",
    title: "How to Upgrade From HDB to Private — Without Cash Top-Up",
    excerpt:
      "A practical walkthrough of the timing, financing, and decoupling strategies that have unlocked private property for hundreds of HDB owners.",
    category: "Upgrading",
    date: "Nov 2025",
    readTime: "8 min read",
    image:
      "https://images.pexels.com/photos/28853362/pexels-photo-28853362.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "b2",
    title: "Reading the 2026 Singapore Property Cycle",
    excerpt:
      "Where we are in the cycle, what to watch in the next 12 months, and how to position your portfolio for the next leg of growth.",
    category: "Market Insights",
    date: "Oct 2025",
    readTime: "6 min read",
    image:
      "https://images.unsplash.com/photo-1605346475807-2088e0897b2d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxzaW5nYXBvcmUlMjBsdXh1cnklMjBjb25kbyUyMGludGVyaW9yfGVufDB8fHx8MTc4MDA1MTczN3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "b3",
    title: "The Quiet Power of Decoupling in Singapore",
    excerpt:
      "Why decoupling remains one of the most underused — yet most powerful — moves for married couples building a property portfolio.",
    category: "Strategy",
    date: "Sep 2025",
    readTime: "10 min read",
    image:
      "https://images.unsplash.com/photo-1494526585095-c41746248156?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBob21lJTIwZXh0ZXJpb3IlMjBtb2Rlcm4lMjB3YXJtJTIwbGlnaHR8ZW58MHx8fHwxNzgwMDUxNzQ0fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const BLOG_CATEGORIES = ["All", "Upgrading", "Market Insights", "Strategy"];

export const ENQUIRY_TYPES = [
  "I'm thinking of selling",
  "I'm looking to buy",
  "I want to upgrade",
  "Investment / second property",
  "Property valuation",
  "Marketing my listing",
  "General enquiry",
];
